import {Component, Input, OnInit} from '@angular/core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'mandant-waffle',
  templateUrl: './mandant-waffle.component.html',
  styles: []
})
export class MandantWaffleComponent extends ExcTranslation implements OnInit {

  @Input('Mandant') Mandant;
  constructor(private excDss: DefaultSettingsService) {
    super();
  }

  ngOnInit() {
  }

}
